// import {
//   commonParams
// } from './config'
import axios from 'axios'
import {HOSTURL} from './config'

export function getLyric(mid) {
  // const url = '/api/lyric'

  // const data = Object.assign({}, commonParams, {
  //   songmid: mid,
  //   platform: 'yqq',
  //   hostUin: 0,
  //   needNewCode: 0,
  //   categoryId: 10000000,
  //   pcachetime: +new Date(),
  //   format: 'json'
  // })

  // return axios.get(url, {
  //   params: data
  // }).then((res) => {
  //   return Promise.resolve(res.data)
  // })

  const url = '/lyric'
  const data = {
    id: mid
  }

  return axios.get(`${HOSTURL}${url}`, {
    params: data
  }).then((res) => {
    return Promise.resolve(res.data);
  })
};

/* 获取播放源连接密钥 */
export function getVkey(songmid) {
  // const url = '/api/vkey'

  // const data = Object.assign({}, commonParams, {
  //   songmid: songmid,
  //   filename: `C400${songmid}.m4a`,
  //   guid: "1472133172",
  //   uin: 0,
  //   platform: 'yqq',
  //   needNewCode: 0,
  //   cid: "205361747",
  //   format: 'json'
  // })

  // return axios.get(url, {
  //   params: data
  // }).then((res) => {
  //   return Promise.resolve(res.data)
  // })

  const url = '/song/url'
  const data = {
    id: songmid
  }

  return axios.get(`${HOSTURL}${url}`, {
    params: data
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

export function getSongDetail(songmid) {
  const url = '/song/detail'
  const data = {
    ids: songmid
  }

  return axios.get(`${HOSTURL}${url}`, {
    params: data
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 收藏歌曲 mark
export function SongLike(songid, flag) {
  const url = '/like'

  const data = {
    id: songid,
    like: flag
  }

  return axios.get(`${HOSTURL}${url}`, {
    withCredentials: true,
    params: data
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/song.js